import { render, staticRenderFns } from "./aggregatedPromptTable.vue?vue&type=template&id=77437581&scoped=true&"
import script from "./aggregatedPromptTable.vue?vue&type=script&lang=js&"
export * from "./aggregatedPromptTable.vue?vue&type=script&lang=js&"
import style0 from "./aggregatedPromptTable.vue?vue&type=style&index=0&id=77437581&lang=scss&scoped=true&"
import style1 from "./aggregatedPromptTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77437581",
  null
  
)

export default component.exports